export default __webpack_public_path__ + "fonts/iot_1.70500ec34c5781236a03616509567f50.png";